import { get, post } from '@/libs/api.request'

export default {
  state: {
    lookBoomTree: null
  },
  getters: {

  },
  mutations: {
    setBomTree(state, bomTree) {
      state.lookBoomTree = bomTree
    }
  },
  actions: {
    loadBomVersion ({ commit }, { bomId, version }) {
      return get(`bom/${bomId}/version/${version}`).then(res => {
        return res.data
      })
    },
    loadBomVersionTree ({ commit }, { bomId, version }) {
      return get(`bom/${bomId}/version/${version}/tree`).then(res => {
        commit('setBomTree', res.data)
        return res
      })
    },
    getBomVersions ({ commit }, { id, data }) {
      return get(`bom/${id}/versions`, data)
    },
    createBomVersion ({ commit }, { id, data }) {
      return post(`bom/${id}/new-version`, data)
    }
  }
}
